/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createErrorResponseFromDiscriminatorValue, createInternalErrorResponseFromDiscriminatorValue, createViewCompanyDocsMessageResponseFromDiscriminatorValue, type ErrorResponse, type InternalErrorResponse, type ViewCompanyDocsMessageResponse } from '../../../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/messagecenter/companydocs/{messageId}
 */
export interface WithMessageItemRequestBuilder extends BaseRequestBuilder<WithMessageItemRequestBuilder> {
    /**
     * Retrieves a company documents message with subject, body, attachments, and delivery status. Fully anonymous - no authentication required.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<ViewCompanyDocsMessageResponse>}
     * @throws {ErrorResponse} error when the service returns a 400 status code
     * @throws {ErrorResponse} error when the service returns a 404 status code
     * @throws {InternalErrorResponse} error when the service returns a 500 status code
     */
     get(requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<ViewCompanyDocsMessageResponse | undefined>;
    /**
     * Retrieves a company documents message with subject, body, attachments, and delivery status. Fully anonymous - no authentication required.
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toGetRequestInformation(requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const WithMessageItemRequestBuilderUriTemplate = "{+baseurl}/api/messagecenter/companydocs/{messageId}";
/**
 * Metadata for all the requests in the request builder.
 */
export const WithMessageItemRequestBuilderRequestsMetadata: RequestsMetadata = {
    get: {
        uriTemplate: WithMessageItemRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            404: createErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
            500: createInternalErrorResponseFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createViewCompanyDocsMessageResponseFromDiscriminatorValue,
    },
};
/* tslint:enable */
/* eslint-enable */
